import { useCallback } from "react";
import shiftMore from "../../../../../assets/svg/shiftMore.svg";
import shiftView from "../../../../../assets/svg/shiftView.svg";
import shiftDuplicate from "../../../../../assets/svg/shiftDuplicate.svg";
import shiftEdit from "../../../../../assets/svg/shiftEdit.svg";
import shiftTrash from "../../../../../assets/svg/shiftTrash.svg";

const RoleActionsMenu = ({
  val,
  shiftUUID,
  moreOptionRoleUUID,
  toggleMoreOptions,
  onViewRole,
  duplicateRole,
  onEditRole,
  setRoleShiftToDelete,
  setShowDeleteRoleModal
}) => {
  const isOpen = moreOptionRoleUUID === val?.uuid;

  const toggleMenu = useCallback(
    (e) => {
      if (isOpen) toggleMoreOptions();
      else toggleMoreOptions(val?.uuid);
      e.stopPropagation();
    },
    [isOpen, toggleMoreOptions, val?.uuid]
  );

  return (
    <div className="flex justify-around items-center">
      <div className="flex relative">
        {/* Trigger icon */}
        <div className="cursor-pointer rotate-90" onClick={toggleMenu}>
          <img src={shiftMore} alt="more-options" />
        </div>

        {/* Dropdown content */}
        <div
          className={`absolute top-[90%] -right-5 min-w-[125px] bg-white z-10 transition-all ${
            isOpen ? "max-h-auto py-[5px]" : "max-h-0 overflow-hidden py-0"
          }`}
        >
          <div className="flex flex-col border border-[#CBCBCB] rounded-md text-black font-medium text-xs">

            {/* View */}
            <div
              className="border-b border-b-[#CBCBCB] hover:bg-[#E0E4EB] cursor-pointer"
              onClick={() =>
                onViewRole({ roleUUID: val?.uuid, shiftUUID })
              }
            >
              <div className="flex py-[5px] mx-[13px]">
                <img src={shiftView} alt="view" />
                <span className="ml-[14px] text-grayBlack text-sm font-normal">
                  View
                </span>
              </div>
            </div>

            {/* Duplicate */}
            <div
              className="border-b border-b-[#CBCBCB] hover:bg-[#E0E4EB] cursor-pointer"
              onClick={() => duplicateRole(val?.uuid, shiftUUID)}
            >
              <div className="flex py-[5px] mx-[15px]">
                <img src={shiftDuplicate} alt="duplicate" />
                <span className="ml-4 text-grayBlack text-sm font-normal">
                  Duplicate
                </span>
              </div>
            </div>

            {/* Edit */}
            <div
              className="border-b border-b-[#CBCBCB] hover:bg-[#E0E4EB] cursor-pointer"
              onClick={() =>
                onEditRole({ roleUUID: val?.uuid, shiftUUID })
              }
            >
              <div className="flex py-[5px] mx-[15px]">
                <img src={shiftEdit} alt="edit" />
                <span className="ml-4 text-grayBlack text-sm font-normal">
                  Edit
                </span>
              </div>
            </div>

            {/* Remove */}
            <div
              className="hover:bg-[#E0E4EB] cursor-pointer"
              onClick={() => {
                setRoleShiftToDelete({ roleUUID: val?.uuid, shiftUUID });
                setShowDeleteRoleModal(true);
              }}
            >
              <div className="flex py-[5px] mx-[15px]">
                <img src={shiftTrash} alt="delete" />
                <span className="ml-4 text-grayBlack text-sm font-normal">
                  Remove
                </span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default RoleActionsMenu;
